const roles = {
  ADMIN: 'admin',
  APPROVER: 'approver',
  SELLER: 'seller',
  REVIEWER: 'reviewer',
  ENTITLEMENT_VIEWER: 'Entitlement_Viewer',
  ENTITLEMENT_FLM: 'Entitlement_FLM',
  ENTITLEMENT_ADMIN: 'Entitlement_Admin',
  HW_REFRESH_VIEWER: 'HW_Refresh_Viewer',
  HW_REFRESH_FLM: 'HW_Refresh_FLM',
  HW_REFRESH_ADMIN: 'HW_Refresh_Admin',
  HW_REFRESH_EOL_DATE_UPDATE: 'HW_Refresh_EOL_Date_Update',
  FORECAST_VIEWER: 'Forecast_Viewer',
  FORECAST_EDITOR: 'Forecast_Editor',
  SALESPLAY_EDITOR: 'Salesplay_Editor',
  SALESPLAY_ADMIN: 'Salesplay_Admin',
  COMPETITIVE_TAKEOUT_EDITOR: 'Competitive_Takeout_Editor',
  BP: 'bp',
  FEDERAL_SELLER: 'Federal_Seller',
  CADENCE_VIEWER: 'Cadence_Viewer',
  CADENCE_EDITOR: 'Cadence_Editor',
};

export default roles;
